import LaboratoryM from "@/views/laboratoryM/laboratoryM"

export default {
    path: '/LaboratoryM',
    name: 'LaboratoryM',
    component: LaboratoryM,
  }


// WEBPACK FOOTER //
// ./src/router/LaboratoryM/index.js